import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

class NotFound extends PureComponent {
    componentDidMount() {
        this.props.setWhiteLogo(false);
        this.animatePage();
    }

    animatePage() {
        const page = document.getElementById('NotFound');

        setTimeout(() => {
            page.classList.add('__active');
        }, 100);
    }

    render() {
        return (
            <div className="notfound" id="NotFound">
                <h1 className="notfound-title">Page not found</h1>
                <div className="notfound-button">
                    <Link to="/question/1" className="button">
                        BACK TO QUIZ
                    </Link>
                </div>
            </div>
        );
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js